import {
  Injectable,
} from '@angular/core';
import {
  SeatmapsStore,
} from '@des/store/seatmaps';
import {
  Store,
} from '@ngrx/store';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  retrieveCurrentSeatmap,
} from './fact-factories';
import {
  SeatmapFacts,
} from './seatmap.facts';

@Injectable()
export class SeatmapFactsService extends FactsService<SeatmapFacts> {
  public facts = {
    seatmap: this.store.pipe(retrieveCurrentSeatmap())
  };

  constructor(rulesEngine: RulesEngineRunnerService, private readonly store: Store<SeatmapsStore>) {
    super(rulesEngine);
  }
}
